import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'redux-first-router-link';
// shared
import { ArrowLeftIcon } from 'components/library';
// scss
import './back-button.scss';

export default class BackButton extends React.Component {
    public static propTypes = {
        to: PropTypes.string,
        className: PropTypes.string,
        children: PropTypes.array,
    };

    public goBack = ( event: any ) => {
        event.preventDefault();
        window.history.back();
    }

    public render() {
        const { to, className, children } = this.props as any;
        return to ? (
            <Link aria-label="Go Back" to={to} className={classNames( 'contests-back-btn', className )}>
                {children || <ArrowLeftIcon />}
            </Link>
        ) : (
            <a aria-label="Go Back" onClick={this.goBack} className={classNames( 'contests-back-btn', className )}>
                {children || <ArrowLeftIcon />}
            </a>
        );
    }
}
